/* 🤖 this file was generated by script */
export const wsolidiconKey01 = {
  name: 'key_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M15 2a7 7 0 0 0-6.88 8.4v.06l-.25.25-5.1 5.11-.04.04q-.22.2-.44.5a2 2 0 0 0-.23.59q-.08.36-.06.66v1.82q0 .39.02.7c.02.24.06.5.2.78q.3.57.87.87c.27.14.54.18.77.2q.33.02.7.02H7a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 .7-.3l1.59-1.57.25-.25h.05q.14 0 .47.06.46.06.94.06a7 7 0 1 0 0-14m0 6a1 1 0 0 1 1 1 1 1 0 1 0 2 0 3 3 0 0 0-3-3 1 1 0 1 0 0 2" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
